import { render, staticRenderFns } from "./topicReplyDetail.vue?vue&type=template&id=48045d7d&scoped=true"
import script from "./topicReplyDetail.vue?vue&type=script&lang=js"
export * from "./topicReplyDetail.vue?vue&type=script&lang=js"
import style0 from "./topicReplyDetail.vue?vue&type=style&index=0&id=48045d7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48045d7d",
  null
  
)

export default component.exports